<template>
  <div>
    <div class="login usr">
      <!--h3><img class="logo" src="@/img/logo.png" alt="インテリジェントヘルスケア ストレスチェックApp"></h3-->
      <h3 class="uk-text-center">
        {{ $store.state.common.sScreenTitle }}
      </h3>
      <div v-show="$store.state.common.sIsLoading" class="common-font">
        Loading...
      </div>

      <div v-show="!$store.state.common.sIsLoading" class="common-font">
        <!-- 準備中 -->
        <div v-if="$store.state.answer.sScStatusForScreen == 1">
          <div class="r_answer">
            <template v-if="flg">
              <p class="large cntr fwb" v-if="flg == true">
                {{ vScreenOnPreparation.sc_yearmonth }}
              </p>
              <p class="large cntr fwb" v-else>
                {{
                  $t("displayValue_Respondent.PREPARATION_guide_no_preparation")
                }}
              </p>
              <dl>
                <dt>
                  【{{
                    $t("displayValue_Respondent.PREPARATION_guide_sc_period")
                  }}】
                </dt>
                <dd class="uk-margin-bottom">
                  {{ vScreenOnPreparation.sc_period }}
                </dd>
                <dt>
                  【{{
                    $t(
                      "displayValue_Respondent.PREPARATION_guide_answer_format"
                    )
                  }}】
                </dt>
                <dd class="uk-margin-bottom">
                  {{
                    $t("displayValue_Respondent.PREPARATION_answer_format")
                  }}：
                  <p>
                    {{
                      $t(
                        "displayValue_Respondent.PREPARATION_guide_description_answer_format"
                      )
                    }}
                  </p>
                </dd>
                <dt>
                  【{{
                    $t(
                      "displayValue_Respondent.PREPARATION_guide_notice_format"
                    )
                  }}】
                </dt>
                <dd>
                  {{ vScreenOnPreparation.sc_conf_notice_name }}：
                  <p v-show="vScreenOnPreparation.sc_conf_notice == 1">
                    {{
                      $t(
                        "displayValue_Respondent.PREPARATION_guide_description_notice_format_paper"
                      )
                    }}
                  </p>
                  <p v-show="vScreenOnPreparation.sc_conf_notice == 2">
                    {{
                      $t(
                        "displayValue_Respondent.PREPARATION_guide_description_notice_format_web"
                      )
                    }}
                  </p>
                </dd>
              </dl>
            </template>
            <template v-else>
              <h4 class="uk-text-center common-font">
                {{
                  $t(
                    "displayValue_Respondent.PREPARATION_guide_preparation_service"
                  )
                }}
              </h4>
              <p class="large cntr fwb">
                {{
                  $t("displayValue_Respondent.PREPARATION_guide_no_preparation")
                }}
              </p>
            </template>
            <button
              type="button"
              class="uk-button uk-button-secondary uk-width-1-1 common-rounded"
              @click="doGoRespondentHome"
            >
              &lt;&nbsp;{{ $t("displayValue_Respondent.PREPARATION_btn_back") }}
            </button>
          </div>
        </div>

        <!-- 実施中 -->
        <div v-if="$store.state.answer.sScStatusForScreen == 3">
          <!-- Step1 -->
          <div class="r_answer">
            <div v-show="vAnswerStep == 1">
              <template v-if="flg">
                <p class="large cntr fwb">
                  {{ vScreenOnGoing.sc_yearmonth }}<br />{{
                    $t(
                      "displayValue_Respondent.PROGRESS_guide_progress_service"
                    )
                  }}
                </p>
                <dl>
                  <dt>
                    【{{
                      $t("displayValue_Respondent.PROGRESS_guide_sc_end_date")
                    }}】
                  </dt>
                  <dd class="uk-margin-bottom">
                    {{ vScreenOnGoing.sc_answer_end_date }}
                  </dd>
                  <dt>
                    【{{
                      $t(
                        "displayValue_Respondent.PROGRESS_guide_submission_date"
                      )
                    }}】
                  </dt>
                  <span v-if="vAnswerStatus == 2">
                    <dd class="uk-margin-bottom">
                      {{ $t("displayValue_Respondent.PROGRESS_submitted") }}
                      {{ vAnswerCompDate }}
                    </dd>
                  </span>
                  <span v-else>
                    <dd class="uk-margin-bottom">
                      {{ $t("displayValue_Respondent.PROGRESS_no_submitted") }}
                    </dd>
                  </span>
                  <dt>
                    【{{
                      $t(
                        "displayValue_Respondent.PROGRESS_guide_questionnaire"
                      )
                    }}】
                  </dt>
                  <dd>
                    {{
                      $t(
                        "displayValue_Respondent.PROGRESS_guide_description_howto_answer1"
                      )
                    }}<br />
                    {{
                      $t(
                        "displayValue_Respondent.PROGRESS_guide_description_howto_answer2"
                      )
                    }}<br />
                    <em>※</em>
                    {{
                      $t(
                        "displayValue_Respondent.PROGRESS_guide_description_howto_answer3"
                      )
                    }}<br />
                    <em>※</em>
                    {{
                      $t(
                        "displayValue_Respondent.PROGRESS_guide_description_howto_answer4"
                      )
                    }}<br />
                  </dd>
                </dl>
                <button
                  v-if="vAnswerAllDone"
                  :disabled="$store.state.common.sServerProcessing"
                  type="button"
                  class="
                    uk-button uk-button-primary uk-width-1-1 uk-margin-small
                    common-rounded
                  "
                  @click="doDisplayAnswerStep2"
                >
                  {{
                    $t("displayValue_Respondent.PROGRESS_btn_confirm_answer")
                  }}
                </button>
                <template v-else>
                  <button
                    :disabled="$store.state.common.sServerProcessing"
                    type="button"
                    class="
                      uk-button uk-button-primary uk-width-1-1 uk-margin-small
                      common-rounded
                    "
                    @click="doDisplayAnswerStep2"
                  >
                    {{ $t("displayValue_Respondent.PROGRESS_btn_answer") }}
                  </button>
                </template>
                <button
                  type="button"
                  class="
                    uk-button uk-button-secondary uk-width-1-1
                    common-rounded
                  "
                  @click="doGoRespondentHome"
                >
                  &lt;&nbsp;{{
                    $t("displayValue_Respondent.PROGRESS_btn_back")
                  }}
                </button>
              </template>
              <template v-else>
                <h4 class="uk-text-center common-font">
                  {{ $t("displayValue_Respondent.PROGRESS_guide_service") }}
                </h4>
                <p class="large cntr fwb">
                  {{ $t("displayValue_Respondent.PROGRESS_guide_no_progress") }}
                </p>
                <button
                  type="button"
                  class="
                    uk-button uk-button-secondary uk-width-1-1
                    common-rounded
                  "
                  @click="doGoRespondentHome"
                >
                  &lt;&nbsp;{{
                    $t("displayValue_Respondent.PROGRESS_btn_back")
                  }}
                </button>
              </template>
            </div>
          </div>

          <!-- Step2 -->
          <div v-show="vAnswerStep == 2">
            <div v-for="ca in vCategoryDataForAnswer" :key="ca.category_id">
              <p class="qmidashi" v-html="ca.question_text"></p>
              <p class="cntr" style="margin-top: 5px">
                {{
                  $t(
                    "displayValue_Respondent.ANSWER_guide_description_answer_head"
                  )
                }}<br />（&nbsp;{{ vQuestionIndex + 1 }} /
                {{ vQuestionDataForResult.length }}&nbsp;）
              </p>
              <div v-for="qu in vQuestionDataForAnswer" :key="qu.question_id">
                <p class="large150 cntr fwb">
                  {{
                    $t(
                      "displayValue_Respondent.ANSWER_guide_current_answer_prefix"
                    )
                  }}{{ qu.question_id }}.<br />
                  <span v-html="qu.question_text"></span>
                </p>
                <div
                  v-for="(cp, cpIdx) in vChoicePatternForDisplay"
                  :key="cp.choice_id"
                  class="answerbtn"
                >
                  <div
                    v-if="
                      qu.choice_id > 0 &&
                      cpIdx + 1 == qu.choice_id &&
                      vChoiceIndex < 0
                    "
                  >
                    <button
                      :disabled="$store.state.common.sServerProcessing"
                      type="button"
                      class="operate-button answerbtn_now"
                      @click="doChoiceAnswer(cpIdx)"
                    >
                      <!--span class="uk-badge" >済</span><br/-->
                      <span v-html="cp.choice_text"></span>
                    </button>
                  </div>
                  <div
                    v-if="
                      qu.choice_id > 0 &&
                      cpIdx + 1 != qu.choice_id &&
                      vChoiceIndex < 0
                    "
                  >
                    <button
                      :disabled="$store.state.common.sServerProcessing"
                      type="button"
                      class="operate-button"
                      @click="doChoiceAnswer(cpIdx)"
                    >
                      <span v-html="cp.choice_text"></span>
                    </button>
                  </div>
                  <div v-if="vChoiceIndex >= 0 && vChoiceIndex == cpIdx">
                    <!-- 選択時? -->
                    <button
                      :disabled="$store.state.common.sServerProcessing"
                      type="button"
                      class="
                        operate-button-choice-answer
                        answerbtn_now answerbtn_choice
                      "
                    >
                      <b><span v-html="cp.choice_text"></span></b>
                    </button>
                  </div>
                  <div v-if="vChoiceIndex >= 0 && vChoiceIndex != cpIdx">
                    <!-- 選択時の全体の挙動? -->
                    <button
                      :disabled="$store.state.common.sServerProcessing"
                      type="button"
                      class="operate-button"
                    >
                      <span v-html="cp.choice_text"></span>
                    </button>
                  </div>
                  <div v-if="vChoiceIndex < 0 && !qu.choice_id">
                    <button
                      :disabled="$store.state.common.sServerProcessing"
                      type="button"
                      class="operate-button"
                      @click="doChoiceAnswer(cpIdx)"
                    >
                      <span v-html="cp.choice_text"></span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="answer_foot">
              <div v-if="vQuestionIndex > 0">
                <button
                  :disabled="$store.state.common.sServerProcessing"
                  type="button"
                  class="
                    operate-button
                    uk-button uk-button-secondary uk-width-1-1
                    common-rounded
                  "
                  @click="doBackToPreviousQuestion"
                >
                  &lt;&nbsp;{{
                    $t("displayValue_Respondent.ANSWER_btn_previous")
                  }}
                </button>
              </div>
              <div v-else>
                <button
                  :disabled="$store.state.common.sServerProcessing"
                  type="button"
                  class="
                    operate-button
                    uk-button uk-button-secondary uk-width-1-1
                    common-rounded
                  "
                  @click="doChangeAnswerStep(1)"
                >
                  &lt;&nbsp;{{
                    $t("displayValue_Respondent.PROGRESS_btn_back")
                  }}
                </button>
              </div>
              <!-- <div >
            <button :disabled="$store.state.common.sServerProcessing" type="button" class="operate-button" style="width:100%; line-height:3; background-color:#1e90ff; font-size:1.5em; color:#ffffff; border-radius:10px; border:solid 1px #696969;" @click="doSwitchDisplayMode">
            回答状況
            </button>
            </div> -->
            </div>
          </div>

          <!-- Step3 -->
          <div v-show="vAnswerStep == 3" class="answercheck">
            <div class="answercheck_btm">
              <button
                v-if="vAnswerStatus == 2"
                :disabled="$store.state.common.sServerProcessing"
                type="button"
                class="operate-button uk-button-secondary common-rounded"
                @click="doGoRespondentHome"
              >
                &lt;&nbsp;{{ $t("displayValue_Respondent.PROGRESS_btn_back") }}
              </button>
              <!-- <button v-else :disabled="$store.state.common.sServerProcessing" type="button" class="operate-button" @click="doSwitchDisplayMode">
              回答を修正する
            </button> -->
              <div
                v-if="vAnswerAllDone && vAnswerStatus == 1"
                class="uk-padding uk-padding-remove-bottom"
              >
                <button
                  :disabled="$store.state.common.sServerProcessing"
                  type="button"
                  class="
                    operate-button
                    uk-button uk-button-primary
                    common-rounded
                  "
                  style="font-size: 1.5em"
                  @click="doSubmitAnswer"
                >
                  {{ $t("displayValue_Respondent.SUBMIT_btn_submit_answer") }}
                </button>
              </div>
            </div>
            <!-- <p v-if="vAnswerAllDone" class="cntr">
              <strong class="large">全{{ vQuestionDataForResult.length }}問回答済み</strong><br />
              <span v-show="vAnswerStatus == 2">回答提出済み</span>
              <span v-show="vAnswerStatus != 2"><em>回答未提出</em></span>
            </p> -->
            <div v-if="vAnswerAllDone" class="cntr">
              <div>
                <strong class="large">
                  {{
                    replaceLanguageStrValue(
                      $t("displayValue_Respondent.SUBMIT_guide_all_answered"),
                      [vQuestionDataForResult.length]
                    )
                  }}
                </strong>
                <br />
              </div>
              <div style="margin-top: 10px">
                <span v-show="vAnswerStatus == 2">{{
                  $t("displayValue_Respondent.SUBMIT_guide_already_submit")
                }}</span>
                <span
                  v-show="vAnswerStatus != 2"
                  style="font-weight: bold; font-size: 2em; margin-top: 10px"
                  ><em>{{
                    $t("displayValue_Respondent.SUBMIT_guide_no_submitted")
                  }}</em>
                </span>
              </div>
              <div
                v-show="vAnswerStatus != 2"
                style="
                  border: dashed 2px black;
                  margin-top: 20px;
                  margin-bottom: 20px;
                  padding: 10px;
                "
              >
                <div class="blink">
                  <div
                    style="
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      margin-bottom: 10px;
                    "
                  >
                    <div
                      style="
                        background-color: black;
                        color: white;
                        font-weight: bold;
                        padding: 10px;
                        width: 40%;
                        margin-right: 5px;
                        border-radius: 5px;
                        background-color: #1e87f0;
                      "
                    >
                      {{
                        $t("displayValue_Respondent.SUBMIT_btn_submit_answer")
                      }}
                    </div>
                    {{
                      $t(
                        "displayValue_Respondent.SUBMIT_guide_no_submitted_case1"
                      )
                    }}
                  </div>
                  <div
                    style="
                      display: flex;
                      justify-content: center;
                      align-items: center;
                    "
                  >
                    <div style="color: red; font-weight: bold">
                      {{
                        $t(
                          "displayValue_Respondent.SUBMIT_guide_no_submitted_case2"
                        )
                      }}
                    </div>
                    {{
                      $t(
                        "displayValue_Respondent.SUBMIT_guide_no_submitted_case3"
                      )
                    }}
                  </div>
                </div>
              </div>
            </div>

            <div>
              <div v-for="ca in vCategoryDataForResult" :key="ca.category_id">
                <p class="qmidashi" v-html="ca.question_text"></p>
                <div v-for="qu in vQuestionDataForResult" :key="qu.question_id">
                  <div v-if="ca.category_id == qu.category_id">
                    <div
                      :id="qu.category_id + '_' + qu.question_id"
                      class="answer_quest"
                    >
                      <p>{{ qu.question_id }}&nbsp;{{ qu.question_text }}</p>
                    </div>
                    <!-- <button v-if="qu.choice_id > 0" :disabled="$store.state.common.sServerProcessing" type="button" class="operate-button"  @click="doOpenAnswerStep3Modal(qu.category_id, qu.question_id)">
                  <b><span v-html="qu.choice_text"></span></b>
                  </button>
                  <button v-else :disabled="$store.state.common.sServerProcessing" type="button" class="operate-button"  @click="doOpenAnswerStep3Modal(qu.category_id, qu.question_id)">
                  未回答
                  </button> -->
                    <button
                      v-if="qu.choice_id > 0"
                      :disabled="$store.state.common.sServerProcessing"
                      type="button"
                      class="answer_answer common-rounded"
                      @click="
                        doReChoiceAtAnswerList(qu.category_id, qu.question_id)
                      "
                    >
                      <span v-html="qu.choice_text"></span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 回答提出後 -->
          <div v-if="vAfterSubmit">
            <h4 class="uk-text-center common-font">
              {{ $t("displayValue_Respondent.SUBMIT_msg_answer_submitted") }}
            </h4>
            <p>
              {{
                $t(
                  "displayValue_Respondent.SUBMIT_guide_description_submitted1"
                )
              }}<br />
              {{
                $t(
                  "displayValue_Respondent.SUBMIT_guide_description_submitted2"
                )
              }}<br />
              {{
                $t(
                  "displayValue_Respondent.SUBMIT_guide_description_submitted3"
                )
              }}
            </p>
            <button
              :disabled="$store.state.common.sServerProcessing"
              type="button"
              class="
                operate-button
                uk-button uk-button-secondary
                common-rounded
              "
              @click="doGoRespondentHome"
            >
              {{ $t("displayValue_Respondent.SUBMIT_btn_go_home") }}
            </button>
          </div>
        </div>
        <!-- 回答一覧内モーダル -->
        <!-- <div :id="vModalIdForAnswer" uk-modal>
      <div class="uk-modal-dialog uk-width-auto" >
      <button class="uk-modal-close-default" type="button" uk-close></button>
      <div class="uk-modal-body" uk-overflow-auto>
      <div v-for="qu in vQuestionDataForModal" :key="qu.question_id">
      <div >
      <b>{{ qu.question_id }}.{{ qu.question_text }}</b>
      </div>
      <div >
      <div v-for="cp in vChoicePatternForModal" :key="cp.choice_id" >
      <div >
      <button :disabled="$store.state.common.sServerProcessing" type="button" class="operate-button"  @click="doChoiceAnswerAtModal(cp.choice_id)">
      <div v-if="qu.choice_id == cp.choice_id">
      <span class="uk-badge" >済</span><br/>
      <span v-html="cp.choice_text"></span>
      </div>
      <div v-else>
      <span v-html="cp.choice_text"></span>
      </div>
      </button>
      </div>
      </div>
      </div>
      </div>
      </div>
      </div>
      </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import constant from "@/constant.js";
import UIkit from "uikit";

export default {
  data() {
    return {
      tmp: null,
      vComId: this.$store.state.common.sComId,
      vEmpCode: this.$store.state.common.sUserCode,
      vScId: this.$store.state.answer.sScId,

      vQuestionListData: [], // 質問情報
      vChoicePatternListData: [], // 選択肢情報
      vCategoryDataForAnswer: [], // 質問カテゴリ（回答用）
      vQuestionDataForAnswer: [], // 質問（回答用）
      vCategoryDataForResult: [], // 質問カテゴリ（一覧確認用）
      vQuestionDataForResult: [], // 質問（一覧確認用）
      vChoicePatternForDisplay: [], // 選択肢（表示用）

      vAnswerStatus: 0, // 回答状態
      vAnswerCompDate: "", // 回答完了年月日
      // vAnswerCount: 0,
      vAfterSubmit: false, // 回答提出直後判定（回答ありがとうメッセージ表示する用）
      vAnswerStep: 1, // 実施中画面のステップ（1:導入、2:アンケート、3:回答一覧確認）

      vCategoryId: 0, // カテゴリID（表示制御用）
      vQuestionId: 0, // 質問ID（表示制御用）
      vQuestionIndex: 0, // 質問インデックス
      vChoiceId: 0, // 選択肢id
      vChoiceIndex: -1, // 選択肢ボタンの外観制御のためのもの
      // vNowQuestionIndex: 0, // 現在表示している質問index

      vLatestCategoryId: 0, // 最終到達質問カテゴリid
      vLatestQuestionId: 0, // 最終到達質問id
      vLatestQuestionIndex: 0, // 最終到達質問index
      vAnswerAllDone: false, // 全て回答済み判定
      // vAbleSubmission: false, // 回答提出可能判定
      // vCountChoicedAnswer: 0, // 回答数

      flg: false,

      vScreenOnPreparation: {
        // 準備中用
        sc_yearmonth: "",
        sc_conf_answer: "",
        sc_conf_answer_name: "",
        sc_conf_notice: "",
        sc_conf_notice_name: "",
        sc_year: 0,
        sc_month: 0,
        sc_period: 0,
        s_year: 0,
        s_month: 0,
        s_day: 0,
        s_dayofweek: 0,
        e_year: 0,
        e_month: 0,
        e_day: 0,
        e_dayofweek: 0,
      },
      vScreenOnGoing: {
        // 実施中用
        sc_id: "",
        sc_yearmonth: "",
        sc_answer_end_date: "",
        e_year: 0,
        e_month: 0,
        e_day: 0,
        e_dayofweek: 0,
        c_year: 0,
        c_month: 0,
        c_day: 0,
        c_dayofweek: 0,
      },
      vMessage: "",
      // vModalIdForAnswer: 'modal-confirm-respondent-answer',
      // vQuestionDataForModal: [],
      // vChoicePatternForModal: [],
      // vCategoryIdForModal: '',
      // vQuestionIdForModal: '',
      // vChoiceIdForModal: '',

      // vPositionLeftForScroll: 0,
      // vPostionTopForScroll: 0,
      vFromAnswerList: false, // 回答一覧から修正するつもり判定

      vAnswerSituation: null, // 質問、回答リストを作成する際の状況管理用
    };
  },
  created() {
    // 画面読み込み中・・・
    this.$store.state.common.sIsLoading = true;
    // ログイン状態判定
    this.doAuthLoginInfo();
    if (!this.$store.state.common.sIsLogined) {
      this.$router.push("/login");
    } else {
      // 画面タイトル
      this.$store.commit("common/doSetScreenTitle", {
        vScreenTitle: "",
      });
      // DB参照処理
      if (this.vComId && this.vEmpCode) {
        this.$axios
          .get(constant.cServerRoute.respondent.answer, {
            params: {
              pScStatusForScreen: this.$store.state.answer.sScStatusForScreen,
              pAnswerStep: this.vAnswerStep,
              pComId: this.vComId,
              pEmpCode: this.vEmpCode,
              pLanguageType: this.$store.state.common.sLanguageTypeNow,
            },
          })
          .then(
            function (response) {
              console.log(response);
              if (
                response.data.return_result ==
                constant.cServerReturnResult.success
              ) {
                // どのページを表示するか分ける
                switch (this.$store.state.answer.sScStatusForScreen) {
                  // 準備中
                  case this.$store.state.answer.sAnswerScreen.preparation:
                    if (response.data.flg) {
                      this.flg = response.data.flg;
                      this.vScreenOnPreparation = {
                        sc_conf_answer:
                          response.data.return_data.sc_conf_answer,
                        sc_conf_answer_name:
                          response.data.return_data.sc_conf_answer_name,
                        sc_conf_notice:
                          response.data.return_data.sc_conf_notice,
                        sc_year: response.data.return_data.sc_year,
                        sc_month: response.data.return_data.sc_month,
                        s_year: response.data.return_data.s_year,
                        s_month: response.data.return_data.s_month,
                        s_day: response.data.return_data.s_day,
                        s_dayofweek: response.data.return_data.s_dayofweek,
                        e_year: response.data.return_data.e_year,
                        e_month: response.data.return_data.e_month,
                        e_day: response.data.return_data.e_day,
                        e_dayofweek: response.data.return_data.e_dayofweek,
                        sc_yearmonth:
                          this.formatImplementationYearMonthPreparation({
                            sc_year: response.data.return_data.sc_year,
                            sc_month: response.data.return_data.sc_month,
                          }),
                        sc_period: this.formatImplementationPeriod({
                          s_year: response.data.return_data.s_year,
                          s_month: response.data.return_data.s_month,
                          s_day: response.data.return_data.s_day,
                          s_dayofweek: response.data.return_data.s_dayofweek,
                          e_year: response.data.return_data.e_year,
                          e_month: response.data.return_data.e_month,
                          e_day: response.data.return_data.e_day,
                          e_dayofweek: response.data.return_data.e_dayofweek,
                        }),
                        sc_conf_notice_name: this.getNoticeFormatName(
                          response.data.return_data.sc_conf_notice
                        ),
                      };
                    }
                    this.$store.commit("common/doEndServerProcess");
                    break;

                  // 実施中
                  case this.$store.state.answer.sAnswerScreen.ongoing:
                    if (response.data.flg) {
                      this.flg = response.data.flg;
                      this.vScreenOnGoing = {
                        sc_id: response.data.return_data.sc_id,
                        sc_year: response.data.return_data.sc_year,
                        sc_month: response.data.return_data.sc_month,
                        e_year: response.data.return_data.e_year,
                        e_month: response.data.return_data.e_month,
                        e_day: response.data.return_data.e_day,
                        e_dayofweek: response.data.return_data.e_dayofweek,
                        c_year: response.data.return_data.c_year,
                        c_month: response.data.return_data.c_month,
                        c_day: response.data.return_data.c_day,
                        c_dayofweek: response.data.return_data.c_dayofweek,
                        sc_yearmonth:
                          this.formatImplementationYearMonthProgress({
                            sc_year: response.data.return_data.sc_year,
                            sc_month: response.data.return_data.sc_month,
                          }),
                        sc_answer_end_date: this.formatImplementationYMD({
                          year: response.data.return_data.e_year,
                          month: response.data.return_data.e_month,
                          day: response.data.return_data.e_day,
                          dayofweek: response.data.return_data.e_dayofweek,
                        }),
                      };
                      this.vAnswerStatus =
                        response.data.return_data.answer_status;

                      this.vAnswerAllDone =
                        response.data.return_answer_all_done;
                      this.vAnswerCompDate = this.formatImplementationYMD({
                        year: response.data.return_data.c_year,
                        month: response.data.return_data.c_month,
                        day: response.data.return_data.c_day,
                        dayofweek: response.data.return_data.c_dayofweek,
                      });
                    }
                    this.$store.commit("common/doEndServerProcess");
                    break;

                  // 実施済み
                  // case this.$store.state.answer.sScStatusForScreen.performed:
                  //   break;
                }
              } else {
                this.vMessage = response.data.return_message;
                this.$store.commit("common/doEndServerProcess");
              }
            }.bind(this)
          )
          .catch(function (error) {
            console.log(error);
            this.vMessage = error;
            this.$store.commit("common/doEndServerProcess");
          });
      }
    }
  },
  // 画面読み込み終わった？
  mounted() {
    this.$store.state.common.sIsLoading = false;
    document.title = "回答ページ";
  },
  computed: {},
  methods: {
    // 質問を表示する
    doDisplayAnswerStep2() {
      // DB参照処理
      this.vScId = this.vScreenOnGoing.sc_id;
      if (this.vComId && this.vEmpCode) {
        // ボタン制御
        this.$store.commit("common/doStartServerProcess");
        this.vMessage = "";
        this.$axios
          .get(constant.cServerRoute.respondent.answer, {
            params: {
              pScStatusForScreen: this.$store.state.answer.sScStatusForScreen,
              // pAnswerStep: this.vAnswerStep,
              pAnswerStep: this.$store.state.answer.sAnswerStep.question,
              pComId: this.vComId,
              pEmpCode: this.vEmpCode,
              pScId: this.vScreenOnGoing.sc_id,
            },
          })
          .then(
            function (response) {
              console.log(response);
              // アンケート情報参照処理判定
              if (
                response.data.return_result ==
                constant.cServerReturnResult.success
              ) {
                // 選択肢情報を保持する
                if (response.data.return_data_choice) {
                  this.vChoicePatternListData =
                    response.data.return_data_choice;
                }
                // 質問情報を保持する
                if (response.data.return_data_question) {
                  this.vQuestionListData = response.data.return_data_question;
                  // 質問リストを整形する
                  this.vAnswerSituation =
                    this.$store.state.answer.sCreateQuestionSituation.first;
                  this.doCreateQuestionForDisplay();
                  if (this.vAnswerAllDone) {
                    this.vAnswerStep =
                      this.$store.state.answer.sAnswerStep.result;
                  } else {
                    this.vAnswerStep =
                      this.$store.state.answer.sAnswerStep.question;
                  }
                }
                // ボタン制御
                this.$store.commit("common/doEndServerProcess");
              } else {
                this.vMessage = response.data.return_message;
                // ボタン制御
                this.$store.commit("common/doEndServerProcess");
              }
            }.bind(this)
          )
          .catch(function (error) {
            console.log(error);
            this.vMessage = error;
            // ボタン制御
            this.$store.commit("common/doEndServerProcess");
          });
      }
    },

    // 質問情報を整形する
    doCreateQuestionForDisplay(changeLang = 0) {
      // 回答提出時の場合は何もしない
      if (
        this.vAnswerSituation ==
        this.$store.state.answer.sCreateQuestionSituation.submit
      ) {
        return;
      }

      // 元となるリスト
      // カテゴリ（質問タイプ = カテゴリ、言語タイプ = 現在選択している言語）
      var tmpArrayCategory = this.vQuestionListData.filter(
        (a) =>
          a.question_type == this.$store.state.answer.sQuestionType.category &&
          a.language_type == this.$store.state.common.sLanguageTypeNow
      );
      // 質問（質問タイプ = 各質問、言語タイプ = 現在選択している言語）
      var tmpArrayQuestion = this.vQuestionListData.filter(
        (a) =>
          a.question_type == this.$store.state.answer.sQuestionType.question &&
          a.language_type == this.$store.state.common.sLanguageTypeNow
      );

      // 回答状況確認用のリスト
      // カテゴリ（質問タイプ = カテゴリ、言語タイプ = 現在選択している言語）
      this.vCategoryDataForResult = this.vQuestionListData.filter(
        (a) =>
          a.question_type == this.$store.state.answer.sQuestionType.category &&
          a.language_type == this.$store.state.common.sLanguageTypeNow
      );
      // 質問（質問タイプ = 各質問、言語タイプ = 現在選択している言語）
      this.vQuestionDataForResult = this.vQuestionListData.filter(
        (a) =>
          a.question_type == this.$store.state.answer.sQuestionType.question &&
          a.language_type == this.$store.state.common.sLanguageTypeNow
      );

      // 言語を変更した場合
      if (changeLang > 0) {
        if (tmpArrayQuestion.length > 0) {
          // 最終到達質問情報を取得しておく（どこまで回答しているか）
          this.doGetLatestQuestionInfo(tmpArrayQuestion);
          this.vCategoryId = this.vLatestCategoryId;
          this.vQuestionId = this.vLatestQuestionId;
          // 質問抽出
          this.vQuestionDataForAnswer = tmpArrayQuestion.filter(
            (a) =>
              a.category_id == this.vCategoryId &&
              a.language_type == this.$store.state.common.sLanguageTypeNow
          );
        }

        // カテゴリ抽出
        this.vCategoryDataForAnswer = tmpArrayCategory.filter(
          (a) =>
            a.category_id == this.vCategoryId &&
            a.language_type == this.$store.state.common.sLanguageTypeNow
        );
        // 質問抽出
        this.vQuestionDataForAnswer = this.vQuestionDataForAnswer.filter(
          (a) =>
            a.question_id == this.vQuestionId &&
            a.language_type == this.$store.state.common.sLanguageTypeNow
        );
        // 選択肢抽出
        this.vChoicePatternForDisplay = this.vChoicePatternListData.filter(
          (a) =>
            a.category_id == this.vCategoryId &&
            a.language_type == this.$store.state.common.sLanguageTypeNow
        );

        this.vQuestionIndex = this.vQuestionDataForResult.filter(
          (a) =>
            a.category_id == this.vCategoryId &&
            a.question_id == this.vQuestionId &&
            a.language_type == this.$store.state.common.sLanguageTypeNow
        )[0].question_index;
        return;
      }

      // 回答する状況によって値を決定する
      switch (this.vAnswerSituation) {
        // 初期表示
        case this.$store.state.answer.sCreateQuestionSituation.first:
          if (tmpArrayQuestion.length > 0) {
            // 最終到達質問情報を取得しておく（どこまで回答しているか）
            this.doGetLatestQuestionInfo(tmpArrayQuestion);
            this.vCategoryId = this.vLatestCategoryId;
            this.vQuestionId = this.vLatestQuestionId;
            // 質問抽出
            this.vQuestionDataForAnswer = tmpArrayQuestion.filter(
              (a) =>
                a.category_id == this.vCategoryId &&
                a.language_type == this.$store.state.common.sLanguageTypeNow
            );
          }
          break;

        // 次の質問へ進む
        case this.$store.state.answer.sCreateQuestionSituation.next:
          if (!this.vFromAnswerList) {
            // 最終到達質問情報を取得しておく
            this.doGetLatestQuestionInfo(tmpArrayQuestion);
            // 最終問題の場合は回答一覧確認画面を表示
            if (this.vQuestionIndex + 1 == tmpArrayQuestion.length) {
              this.vCategoryId = this.vLatestCategoryId;
              this.vQuestionId = this.vLatestQuestionId;
              // this.vAnswerStep = this.$store.state.answer.sAnswerStep.result;
              this.vAnswerAllDone = true;
            } else {
              if (
                this.vCategoryId == this.$store.state.answer.sCategoryType.d
              ) {
                this.vQuestionId += 1;
              } else {
                // 質問抽出
                this.vQuestionDataForAnswer = tmpArrayQuestion.filter(
                  (a) =>
                    a.category_id == this.vCategoryId &&
                    a.language_type == this.$store.state.common.sLanguageTypeNow
                );
                if (this.vQuestionId == this.vQuestionDataForAnswer.length) {
                  this.vCategoryId += 1;
                  this.vQuestionId = 1;
                  moreFilter = true;
                } else {
                  this.vQuestionId += 1;
                }
                this.vAnswerStatus = 1;
              }
            }
          }
          // 質問抽出
          this.vQuestionDataForAnswer = tmpArrayQuestion.filter(
            (a) =>
              a.category_id == this.vCategoryId &&
              a.language_type == this.$store.state.common.sLanguageTypeNow
          );
          break;

        // 質問1つ戻る
        case this.$store.state.answer.sCreateQuestionSituation.previous:
          var moreFilter = false;
          if (this.vCategoryId == this.$store.state.answer.sCategoryType.a) {
            this.vQuestionId -= 1;
          } else {
            if (this.vQuestionId == 1) {
              this.vCategoryId -= 1;
              moreFilter = true;
            } else {
              this.vQuestionId -= 1;
            }
          }
          // 質問抽出
          this.vQuestionDataForAnswer = tmpArrayQuestion.filter(
            (a) =>
              a.category_id == this.vCategoryId &&
              a.language_type == this.$store.state.common.sLanguageTypeNow
          );
          if (moreFilter) {
            this.vQuestionId = this.vQuestionDataForAnswer.length;
          }
          break;

        default:
          this.vQuestionDataForAnswer = tmpArrayQuestion.filter(
            (a) =>
              a.category_id == this.vCategoryId &&
              a.language_type == this.$store.state.common.sLanguageTypeNow
          );
          break;
      }

      // カテゴリ抽出
      this.vCategoryDataForAnswer = tmpArrayCategory.filter(
        (a) =>
          a.category_id == this.vCategoryId &&
          a.language_type == this.$store.state.common.sLanguageTypeNow
      );
      // 質問抽出
      this.vQuestionDataForAnswer = this.vQuestionDataForAnswer.filter(
        (a) =>
          a.question_id == this.vQuestionId &&
          a.language_type == this.$store.state.common.sLanguageTypeNow
      );
      // 選択肢抽出
      this.vChoicePatternForDisplay = this.vChoicePatternListData.filter(
        (a) =>
          a.category_id == this.vCategoryId &&
          a.language_type == this.$store.state.common.sLanguageTypeNow
      );
      // 現在表示している質問index
      // this.vQuestionIndex = this.vQuestionDataForResult.findIndex((a)=> a.category_id == this.vCategoryId && a.question_id == this.vQuestionId);

      this.vQuestionIndex = this.vQuestionDataForResult.filter(
        (a) =>
          a.category_id == this.vCategoryId &&
          a.question_id == this.vQuestionId &&
          a.language_type == this.$store.state.common.sLanguageTypeNow
      )[0].question_index;
    },
    // 最終到達質問情報取得（どこまで回答しているか）
    doGetLatestQuestionInfo(array) {
      var i = 0;
      var tmpQuestionIndex = -1;
      // 質問リストをループ処理する
      for (i = 0; i < array.length; i++) {
        // 質問に未回答の場合
        if (!array[i].choice_id) {
          // 未回答の質問を、現在の質問にセットする
          this.vLatestCategoryId = array[i].category_id;
          this.vLatestQuestionId = array[i].question_id;
          // this.vLatestQuestionIndex = i;
          tmpQuestionIndex = i;
          break;
        } else {
          this.vLatestCategoryId = array[i].category_id;
          this.vLatestQuestionId = array[i].question_id;
          this.vLatestQuestionIndex = i;
          // 全ての質問に回答している場合
          if (i + 1 == array.length) {
            // 全問回答済み
            this.vAnswerAllDone = true; // 全回答判定true
            this.vAnswerStep = this.$store.state.answer.sAnswerStep.result; // 表示する画面 = 回答一覧画面
          }
        }
      }
      this.vLatestQuestionIndex = tmpQuestionIndex;
    },
    // 次の質問を表示する
    doChoiceAnswer(index) {
      // ボタン制御
      this.$store.commit("common/doStartServerProcess");
      (this.vChoiceId = index + 1), (this.vChoiceIndex = index); // 選択肢ボタンの外観制御のためにセット
      // DB更新
      this.$axios
        .post(constant.cServerRoute.respondent.answer, {
          pComId: this.vComId,
          pScId: this.vScId,
          pEmpCode: this.vEmpCode,
          pCategoryId: this.vCategoryId,
          pQuestionId: this.vQuestionId,
          pChoiceId: this.vChoiceId,
        })
        .then(
          function (response) {
            console.log(response);
            // 回答子データ更新処理判定
            if (
              response.data.return_result ==
              constant.cServerReturnResult.success
            ) {
              // 質問情報を保持する
              if (response.data.return_data_question) {
                this.vQuestionListData = response.data.return_data_question;
                // ボタン制御
                this.$store.commit("common/doEndServerProcess");
                // 次の質問indexを設定、選択肢をリセット
                window.setTimeout(() => {
                  this.vAnswerSituation =
                    this.$store.state.answer.sCreateQuestionSituation.next;
                  this.doCreateQuestionForDisplay();
                  // 全問回答済み状態（回答一覧からの修正）
                  if (this.vFromAnswerList) {
                    this.vAnswerStep =
                      this.$store.state.answer.sAnswerStep.result;
                    // 回答一覧の元の位置までスクロールさせる
                    this.doScrollWindowIntoView();
                  } else {
                    if (this.vAnswerAllDone) {
                      this.doScrollWindowToTop();
                    }
                  }
                  this.vChoiceIndex = -1;
                }, 600);
              }
              // 値クリアしておく
              // this.doClear();
            } else {
              this.vMessage = response.data.return_message;
              // ボタン制御
              this.$store.commit("common/doEndServerProcess");
            }
          }.bind(this)
        )
        .catch(function (error) {
          // 更新メッセージ表示
          this.$store.commit("common/doNotificationUpdate", {
            vMode: 1,
          });
          console.log(error);
          this.vMessage = error;
          // ボタン制御
          this.$store.commit("common/doEndServerProcess");
        });
    },
    // 質問を1つ戻る
    doBackToPreviousQuestion() {
      if (
        this.vCategoryId >= this.$store.state.answer.sCategoryType.b ||
        (this.vCategoryId == this.$store.state.answer.sCategoryType.a &&
          this.vQuestionId > 1)
      ) {
        this.vAnswerSituation =
          this.$store.state.answer.sCreateQuestionSituation.previous;
        this.doCreateQuestionForDisplay();
      }
    },
    // 回答を提出する
    doSubmitAnswer() {
      // ボタン制御
      this.$store.commit("common/doStartServerProcess");
      // DB更新
      this.$axios
        .post(constant.cServerRoute.respondent.answer_submit, {
          pComId: this.vComId,
          pScId: this.vScId,
          pEmpCode: this.vEmpCode,
        })
        .then(
          function (response) {
            console.log(response);
            // 回答親データ更新処理判定
            if (
              response.data.return_result ==
              constant.cServerReturnResult.success
            ) {
              // 質問情報を保持する
              if (response.data.return_data_question) {
                this.vQuestionListData = response.data.return_data_question;
                // 次の質問indexを設定、選択肢をリセット
                window.setTimeout(() => {
                  this.vAnswerSituation =
                    this.$store.state.answer.sCreateQuestionSituation.submit;
                  this.doCreateQuestionForDisplay();
                  this.vChoiceIndex = -1;
                  this.vAnswerStep = 0;
                  this.vAfterSubmit = true;
                }, 600);
              }
              // ボタン制御
              this.$store.commit("common/doEndServerProcess");
              // 値クリアしておく
              // this.doClear();
            } else {
              this.vMessage = response.data.return_message;
              // ボタン制御
              this.$store.commit("common/doEndServerProcess");
            }
          }.bind(this)
        )
        .catch(function (error) {
          // 更新メッセージ表示
          this.$store.commit("common/doNotificationUpdate", {
            vMode: 1,
          });
          console.log(error);
          this.vMessage = error;
          // ボタン制御
          this.$store.commit("common/doEndServerProcess");
        });
    },

    // 回答一覧から回答を修正
    doReChoiceAtAnswerList(categoryId, questionId) {
      this.vFromAnswerList = true;
      this.vCategoryId = categoryId;
      this.vQuestionId = questionId;
      this.vAnswerSituation = null;
      this.doCreateQuestionForDisplay();
      this.vAnswerStep = this.$store.state.answer.sAnswerStep.question;

      // // 質問リストを抽出
      // this.vQuestionDataForModal = this.vQuestionListData.filter((a)=> a.question_type == this.$store.state.answer.sQuestionType.question);
      // this.vQuestionDataForModal = this.vQuestionDataForModal.filter((a)=> (a.category_id == categoryId && a.question_id == questionId));
      // // 選択肢リストを抽出
      // this.vChoicePatternForModal = this.vChoicePatternListData.filter((a)=> a.category_id == categoryId);
      // // モーダル用カテゴリID、質問IDを保持する
      // this.vCategoryIdForModal = categoryId;
      // this.vQuestionIdForModal = questionId;
      // console.log('------------------');
      // console.log('this.vCategoryIdForModal = ', this.vCategoryIdForModal);
      // console.log('this.vQuestionIdForModal = ', this.vQuestionIdForModal);
      // // モーダル表示
      // this.doConfirmUpdate(this.vModalIdForAnswer);
    },
    // // 回答一覧で回答を選択
    // doChoiceAnswerAtModal(choiceId) {
    //   // ボタン制御
    //   this.$store.commit('common/doStartServerProcess');
    //   console.log('-------------------');
    //   console.log('this.vCategoryIdForModal = ', this.vCategoryIdForModal);
    //   console.log('this.vQuestionIdForModal = ', this.vQuestionIdForModal);
    //   this.vChoiceIdForModal = choiceId;
    //   console.log('this.vChoiceIdForModal = ', this.vChoiceIdForModal);
    //   // DB更新
    //   this.$axios.post(constant.cServerRoute.respondent.answer, {
    //     pComId: this.vComId,
    //     pScId: this.vScId,
    //     pEmpCode: this.vEmpCode,
    //     pCategoryId: this.vCategoryIdForModal,
    //     pQuestionId: this.vQuestionIdForModal,
    //     pChoiceId: this.vChoiceIdForModal
    //   })
    //     .then(function(response){
    //       console.log(response);
    //       // 回答子データ更新処理判定
    //       if (response.data.return_result == constant.cServerReturnResult.success) {
    //         // 質問情報を保持する
    //         if (response.data.return_data_question) {
    //           this.vQuestionListData = response.data.return_data_question;
    //           // 質問リストを最新状態にする
    //           // this.vQuestionDataForAnswer = this.vQuestionListData.filter((a)=> a.question_type == this.$store.state.answer.sQuestionType.question);
    //           // this.vQuestionDataForResult = this.vQuestionListData.filter((a)=> a.question_type == this.$store.state.answer.sQuestionType.question);
    //           // 質問リストを最新状態にする
    //           this.vCategoryId = this.vCategoryIdForModal;
    //           this.vQuestionId = this.vQuestionIdForModal;
    //           this.doCreateQuestionForDisplay(this.$store.state.answer.sCreateQuestionSituation.next);
    //           // // 次の質問indexを設定、選択肢をリセット
    //           // window.setTimeout(()=> {
    //           //   // ボタン制御
    //           //   this.$store.commit('common/doEndServerProcess');
    //           //   this.doCreateQuestionForDisplay(this.$store.state.answer.sCreateQuestionSituation.next);
    //           //   this.vChoiceIndex = -1;
    //           // }, 600)
    //           // ボタン制御
    //           this.$store.commit('common/doEndServerProcess');
    //           // モーダル閉じる
    //           this.doHideModal(this.vModalIdForAnswer);
    //         }
    //         // 値クリアしておく
    //         // this.doClear();
    //       } else {
    //         this.vMessage = response.data.return_message;
    //         // ボタン制御
    //         this.$store.commit('common/doEndServerProcess');
    //         // モーダル閉じる
    //         this.doHideModal(this.vModalIdForAnswer);
    //       }
    //     }.bind(this))
    //     .catch(function(error){
    //       // 更新メッセージ表示
    //       this.$store.commit('common/doNotificationUpdate', {
    //         'vMode': 1
    //       });
    //       console.log(error);
    //       this.vMessage = error;
    //       // ボタン制御
    //       this.$store.commit('common/doEndServerProcess');
    //       // モーダル閉じる
    //       this.doHideModal(this.vModalIdForAnswer);
    //     })
    // },
    // 回答ページの表示切替
    doChangeAnswerStep(step) {
      this.vAnswerStep = step;
    },
    // 画面スクロールする
    doScrollWindowIntoView() {
      window.setTimeout(() => {
        const elId = this.vCategoryId + "_" + this.vQuestionId;
        document.getElementById(elId).scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
        this.vFromAnswerList = false;
      }, 50);
    },
    // 画面のトップへスクロールする
    doScrollWindowToTop() {
      window.scrollTo({
        left: 0,
        top: 0,
      });
    },

    // 回答者ホームへ
    doGoRespondentHome() {
      this.$router.replace("/respondent-home");
    },
    // ID,パスワード照合
    doAuthLoginInfo() {
      if (sessionStorage.getItem("storageId")) {
        let createHash = require("sha256-uint8array").createHash;
        let tmp = createHash()
          .update(sessionStorage.getItem("storagePw"))
          .digest("hex");
        this.$axios
          .post(constant.cServerRoute.common.login, {
            alias_id: sessionStorage.getItem("storageAliasId"),
            pLoginId: sessionStorage.getItem("storageId"),
            pLoginPw: tmp,
          })
          .then(
            function (response) {
              console.log(response);
              if (
                response.data.return_result !=
                constant.cServerReturnResult.success
              ) {
                this.$store.state.common.sIsLogined = false;
              }
            }.bind(this)
          )
          .catch(function (error) {
            console.log(error);
            this.$store.state.common.sIsLogined = false;
          });
      }
    },
    // 結果通知形式を判定する
    getNoticeFormatName(pVal) {
      let _return = "";
      switch (Number(pVal)) {
        case 1:
          _return = this.vScreenOnPreparation.sc_conf_notice_name = this.$t(
            "displayValue_Respondent.PREPARATION_notice_format_paper"
          );
          break;
        case 2:
          _return = this.vScreenOnPreparation.sc_conf_notice_name = this.$t(
            "displayValue_Respondent.PREPARATION_notice_format_web"
          );
          break;
        default:
          break;
      }
      return _return;
    },
    // 年月を整形して返す（実施予定）
    formatImplementationYearMonthPreparation(pVal) {
      let _return = "";
      _return = this.$t("displayValue_Respondent.PREPARATION_preparation_ym")
        .replace("__replace1__", pVal.sc_year)
        .replace("__replace2__", pVal.sc_month);
      return _return;
    },
    // 年月を整形して返す（実施中）
    formatImplementationYearMonthProgress(pVal) {
      let _return = "";
      _return = this.$t("displayValue_Respondent.PROGRESS_progress_ym")
        .replace("__replace1__", pVal.sc_year)
        .replace("__replace2__", pVal.sc_month);
      return _return;
    },
    // 年月日曜日を整形して期間にして返す
    formatImplementationPeriod(pVal) {
      let _return = "";
      switch (Number(this.$store.state.common.sLanguageTypeNow)) {
        case 1:
          _return = this.$t("displayValue_Respondent.PREPARATION_sc_period")
            .replace("__replace1__", pVal.s_year)
            .replace("__replace2__", pVal.s_month)
            .replace("__replace3__", pVal.s_day)
            .replace(
              "__replace4__",
              this.getDayOfWeekDisplayValue(pVal.s_dayofweek)
            )
            .replace("__replace5__", pVal.e_year)
            .replace("__replace6__", pVal.e_month)
            .replace("__replace7__", pVal.e_day)
            .replace(
              "__replace8__",
              this.getDayOfWeekDisplayValue(pVal.e_dayofweek)
            );
          break;
        case 2:
          _return = this.$t("displayValue_Respondent.PREPARATION_sc_period")
            .replace(
              "__replace1__",
              this.getDayOfWeekDisplayValue(pVal.s_dayofweek)
            )
            .replace("__replace2__", pVal.s_month)
            .replace("__replace3__", pVal.s_day)
            .replace("__replace4__", pVal.s_year)
            .replace(
              "__replace5__",
              this.getDayOfWeekDisplayValue(pVal.e_dayofweek)
            )
            .replace("__replace6__", pVal.e_month)
            .replace("__replace7__", pVal.e_day)
            .replace("__replace8__", pVal.e_year);
          break;
        case 3:
          _return = this.$t("displayValue_Respondent.PREPARATION_sc_period")
            .replace(
              "__replace1__",
              this.getDayOfWeekDisplayValue(pVal.s_dayofweek)
            )
            .replace("__replace2__", pVal.s_day)
            .replace("__replace3__", pVal.s_month)
            .replace("__replace4__", pVal.s_year)
            .replace(
              "__replace5__",
              this.getDayOfWeekDisplayValue(pVal.e_dayofweek)
            )
            .replace("__replace6__", pVal.e_day)
            .replace("__replace7__", pVal.e_month)
            .replace("__replace8__", pVal.e_year);
          break;
        default:
          _return = "言語なし";
          break;
      }
      return _return;
    },
    // 年月日曜日を整形して返す
    formatImplementationYMD(pVal) {
      let _return = "";
      switch (Number(this.$store.state.common.sLanguageTypeNow)) {
        case 1:
          _return = this.$t("displayValue_Respondent.PROGRESS_sc_end_date")
            .replace("__replace1__", pVal.year)
            .replace("__replace2__", pVal.month)
            .replace("__replace3__", pVal.day)
            .replace(
              "__replace4__",
              this.getDayOfWeekDisplayValue(pVal.dayofweek)
            );
          break;
        case 2:
          _return = this.$t("displayValue_Respondent.PROGRESS_sc_end_date")
            .replace(
              "__replace1__",
              this.getDayOfWeekDisplayValue(pVal.dayofweek)
            )
            .replace("__replace2__", pVal.month)
            .replace("__replace3__", pVal.day)
            .replace("__replace4__", pVal.year);
          break;
        case 3:
          _return = this.$t("displayValue_Respondent.PROGRESS_sc_end_date")
            .replace(
              "__replace1__",
              this.getDayOfWeekDisplayValue(pVal.dayofweek)
            )
            .replace("__replace2__", pVal.day)
            .replace("__replace3__", pVal.month)
            .replace("__replace4__", pVal.year);
          break;
        default:
          _return = "言語なし";
          break;
      }
      return _return;
    },
    // 曜日の表記を返す
    // pValはMysqlのDAYOFWEEK（1=日曜日）
    getDayOfWeekDisplayValue(pVal) {
      let _return = "";
      let _days = [];
      switch (Number(this.$store.state.common.sLanguageTypeNow)) {
        case 1:
          _days = ["日", "月", "火", "水", "木", "金", "土"];
          _return = _days[pVal - 1];
          break;
        case 2:
          _days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
          _return = _days[pVal - 1];
          break;
        case 3:
          _days = [
            "chủ nhật",
            "thứ hai",
            "thứ ba",
            "thứ tư",
            "thứ năm",
            "thứ sáu",
            "thứ bảy",
          ];
          _return = _days[pVal - 1];
          break;
        default:
          _return = "言語なし";
          break;
      }
      return _return;
    },
    // 言語切り替え用の文字列置換
    replaceLanguageStrValue(pOrigin, pVal) {
      let _return = pOrigin;
      pVal.forEach((elem, idx) => {
        let _tmpStr = "__replace" + String(idx + 1) + "__";
        _return = pOrigin.replace(_tmpStr, elem);
      });
      return _return;
    },
  },

  // ページを離れる
  beforeRouteLeave() {
    this.$store.state.answer.sScId = "";
    this.$store.state.answer.sScStatusForScreen = 0;
    // UIkit.modal('#' + this.vModalIdForAnswer).$destroy(true);
  },
  watch: {
    // 選択した言語によって日付の表記を整形する
    "$store.state.common.sLanguageTypeNow"(newVal, oldVal) {
      // 結果通知形式
      this.getNoticeFormatName(this.vScreenOnPreparation.sc_conf_notice);
      // 実施予定年月
      this.vScreenOnPreparation.sc_yearmonth =
        this.formatImplementationYearMonthPreparation({
          sc_year: this.vScreenOnPreparation.sc_year,
          sc_month: this.vScreenOnPreparation.sc_month,
        });
      // 実施予定期間
      this.vScreenOnPreparation.sc_period = this.formatImplementationPeriod({
        s_year: this.vScreenOnPreparation.s_year,
        s_month: this.vScreenOnPreparation.s_month,
        s_day: this.vScreenOnPreparation.s_day,
        s_dayofweek: this.vScreenOnPreparation.s_dayofweek,
        e_year: this.vScreenOnPreparation.e_year,
        e_month: this.vScreenOnPreparation.e_month,
        e_day: this.vScreenOnPreparation.e_day,
        e_dayofweek: this.vScreenOnPreparation.e_dayofweek,
      });
      // 実施中年月
      this.vScreenOnGoing.sc_yearmonth =
        this.formatImplementationYearMonthProgress({
          sc_year: this.vScreenOnGoing.sc_year,
          sc_month: this.vScreenOnGoing.sc_month,
        });
      // 回答終了年月日
      this.vScreenOnGoing.sc_answer_end_date = this.formatImplementationYMD({
        year: this.vScreenOnGoing.e_year,
        month: this.vScreenOnGoing.e_month,
        day: this.vScreenOnGoing.e_day,
        dayofweek: this.vScreenOnGoing.e_dayofweek,
      });
      // 回答提出日
      this.vAnswerCompDate = this.formatImplementationYMD({
        year: this.vScreenOnGoing.c_year,
        month: this.vScreenOnGoing.c_month,
        day: this.vScreenOnGoing.c_day,
        dayofweek: this.vScreenOnGoing.c_dayofweek,
      });
      // 質問、回答に反映
      this.doCreateQuestionForDisplay(1);
    },
  },
};
</script>
<style scoped>
.modal {
  padding: 10px 20px;
  border: 2px solid #00a2ff;
  background: #ffffff;
  z-index: 2;
  display: block;
  text-align: center;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 10px;
}

.modal__message {
  margin-top: 10px;
}

#modal-overlay {
  z-index: 1;
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 120%;
  background-color: rgba(0, 0, 0, 0.75);
}

input {
  font-size: 20px;
  padding: 0.2em 0.3em;
  border-radius: 3px;
  border: none;
  background: gainsboro;
}
</style>
